import MasterCrudPage from "../../components/MasterCrudPage";
import { userAwardsCertificateApi, userMasterApi } from "../../api/masterApi";

function userLabel(user) {
  const name = [user.first_name, user.last_name].filter(Boolean).join(" ");
  return name || "User";
}

export default function UserAwardsCertificates() {
  return (
    <MasterCrudPage
      title="Awards & Certificates"
      description="User awards and certificates with multiple image uploads and verification."
      idKey="awards_certificate_id"
      api={userAwardsCertificateApi}
      listLabel="awards & certificates"
      scopeToCurrentUser
      loadExtraOptions={async () => {
        const users = await userMasterApi.list();
        return {
          users: (users || []).map((user) => ({
            value: user.user_id,
            label: userLabel(user),
          })),
        };
      }}
      fields={[
        {
          name: "user_id",
          label: "User",
          type: "select",
          required: true,
          optionsKey: "users",
          placeholder: "Select user",
        },
        {
          name: "title",
          label: "Title",
          type: "text",
          required: true,
          placeholder: "Award or certificate title",
        },
        {
          name: "awarding_body",
          label: "Awarding Body",
          type: "text",
          placeholder: "Organization that issued the award",
        },
        {
          name: "award_date",
          label: "Date",
          type: "date",
        },
        {
          name: "award_images",
          label: "Upload Images",
          type: "files",
          hint: "Select one or more images",
        },
        {
          name: "awards_verified",
          label: "Awards & Certificates Verified",
          type: "checkbox",
          defaultValue: false,
          checkLabel: "Yes",
          verificationField: true,
        },
        {
          name: "awards_verification_by",
          label: "Awards & Certificates Verification By",
          type: "text",
          placeholder: "Verifier name",
          verificationField: true,
        },
        {
          name: "awards_verification_date",
          label: "Awards & Certificates Verification Date",
          type: "date",
          verificationField: true,
        },
        {
          name: "awards_verification_certificate",
          label: "Awards & Certificates Verification Certificate",
          type: "document",
          accept: "image/*,application/pdf,.pdf",
          verificationField: true,
        },
      ]}
      columns={[
        { key: "awards_certificate_id", label: "ID" },
        {
          key: "user_id",
          label: "User",
          render: (item) =>
            [item.user_id, item.first_name, item.last_name].filter(Boolean).join(" ") || "—",
        },
        { key: "title", label: "Title" },
        { key: "awarding_body", label: "Awarding Body" },
        { key: "award_date", label: "Date" },
        { key: "award_images", label: "Images", type: "images" },
        { key: "awards_verified", label: "Verified", render: (item) => (Number(item.awards_verified) === 1 ? "Yes" : "No") },
        { key: "awards_verification_by", label: "Verified By" },
        { key: "awards_verification_date", label: "Verified Date" },
      ]}
    />
  );
}
